<div class="app-study-history-page">
  <app-study-header
    [showDispatchButton]="!!study?.lastDispatch"
  ></app-study-header>
  <div class="scroll-container">
    <div class="page-loading" *ngIf="loading">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div class="page-content" *ngIf="!loading">
      <app-error-snack-bar [message]="errorMessage"></app-error-snack-bar>
      <app-study-history
        [studyHistoryTable]="studyHistoryTable"
      ></app-study-history>
    </div>
  </div>
</div>
